import { useMemo } from "react";

import type { IDuration } from "@similarweb/ui-components";

import type { IPreset } from "./usePresets";

interface IUseSelectedPresetParams {
    duration: IDuration;
    presets: Array<IPreset>;
}

export const useSelectedPreset = ({ duration, presets }: IUseSelectedPresetParams) =>
    useMemo(() => {
        const preset = presets.find(
            ({ value }) => value.from.isSame(duration.from, "day") && value.to.isSame(duration.to, "day"),
        );

        return preset ?? null;
    }, [duration, presets]);
